// @Todo if no date is posted we take the current one
export const getDatePosted = (datePosted?: string | null) => {
  if (datePosted) {
    const date = new Date(datePosted);
    return date.toISOString().split('T')[0];
  }

  return new Date().toISOString().split('T')[0];
};
